import { Controller } from "@hotwired/stimulus"

export class PrintController extends Controller {
  connect() {
    print()
  }
}
